import { StoreState } from "store/index";

export const getFlightsInterlinking = (state: StoreState) => state.flightsInterlinking;
